
<div class="link" routerLink="/backend-users">Back-end Users</div>
<div class="link" routerLink="/site-users">Site Users</div>
<div class="link" routerLink="/orders">Orders</div>
<div class="link" routerLink="/kits">Test Kits</div>
<div class="link" routerLink="/promos">Promos</div>
<div class="link" routerLink="/institutions">Institutions</div>
